module.exports = __webpack_public_path__ + "static/media/cerrajero.21112c8f.png";